import BenchmarkMetricsChangeDialog from './BenchmarkMetricsChangeDialog';

export default BenchmarkMetricsChangeDialog;
